import React, { Component } from "react";
import CommonTemplate from "./commonTemplate";
import Signbutton from "../forms/button";
import { Input } from "../forms/input";
import { connect } from "react-redux";
import { forgotPassword,validatForgotOtp } from "../../store/actions";
import { CommonOtp } from "./otp";
import Image from "../Image";
import { encrypt } from "./login";
class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: { value: "" },
      count: 1,
    };
  }

  changeValue = (event) => {
    this.setState({
      userId: { value: event.target.value },
    });
  };

  showError = () => {
    const {
      userId: { value },
    } = this.state;
    this.setState({
      userId: {
        value,
        isError: !value,
        errorMessage: "User ID is mandatory",
      },
    });
  };

  sendOtp = async () => {
    const {
      userId: { value },
    } = this.state;
    if (!value) {
      this.userIdField.focus();
      this.setState({
        userId: {
          value,
          isError: !value,
          errorMessage: "User ID is mandatory",
        },
      });
    } else {
      this.regenerteOtp();
    }
  };

  submitOtp = async (enteredOtp) => {
    try {
      this.setState({
        loading: true,
      });
      console.log('sdfasdfsdf');
      const { token } = await this.props.validatForgotOtp({
        otp: encrypt(enteredOtp.join("")),
        otpid: encrypt(this.state.otpid),
      });
  
      if (!token) {
        alert("Please Enter valid OTP");
        return;
      }
  
      this.props.history.replace({
        pathname: "/reset-password",
        state: { token },
      });
  
      this.setState({
        loading: false,
      });
    } catch (error) {
      this.setState({
        loading: false,
      });
      alert(error.message || "Please Enter valid OTP");
    }
  };
  

  regenerteOtp = async () => {
    try {
      const {
        userId: { value },
      } = this.state;
      const params = {
        userid: value,
      };
      this.setState({
        loading: true
      })

      const response = await this.props.forgotPassword(params);
      const { otpid } = response;

      this.setState({
        loading: false,
        otpid,
        textOne:
          "OTP has been sent to your registered Email ID and Mobile Number",
      });
    } catch (error) {
      this.setState({ textOne: error?.message, loading: false });
    }
  };

  keyPress = (e) => {
    if (e.key === "Enter") {
      this.sendOtp();
      e.preventDefault();
    }
  };

  render() {
    const { userId, otp, textTwo,otpid } = this.state;
    return (
      <>
        {/* <p className=""
          style={{fontSize:'2.5em',color:'white'}}
        >
          Forgot Password?
        </p> */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 48,
          }}
        >
          <Image src={"/images/kfinkart-logo.svg"} alt="field_image" />
        </div>
        <div className="form_heading">
          <h2> Forgot Password?</h2>
        </div>
        <Input
          name="User ID"
          isDark={true}
          bordercolor="#384455"
          className="Input-field-div-dark"
          placeholder={"User ID"}
          image={"/images/kfin_userid.svg"}
          value={userId.value}
          onChange={this.changeValue}
          onBlur={this.showError}
          isShowError={userId.isError}
          inputref={(ele) => (this.userIdField = ele)}
          errorMessage={userId.errorMessage}
          disabled={!!otpid}
          onKeyPress={this.keyPress}
        />
        {!otpid ? (
          <Signbutton
            buttontitle="Submit"
            onClick={this.sendOtp}
            isDark={true}
          />
        ) : (
          <CommonOtp
            submitOtp={this.submitOtp}
            regenerteOtp={this.regenerteOtp}
            textTwo={textTwo}
          />
        )}
        <div className="text-center mt-2">
          <button
            className="login-no-account-span mouse-pointer border-0 mt-2"
            onClick={() => this.props.history.push("/login")}
          >
            Return to signin
          </button>
        </div>
      </>
    );
  }
}

export default connect(null, { forgotPassword ,validatForgotOtp})(ForgotPassword);
